import { FormikProps } from "formik";
import ValidationErrorMessage from "./ValidationErrorMessage";
import { useState } from "react";
import { defaultIfNullish } from "../../util/stringUtil";
import IsRequired from "./common/IsRequired";
import { get } from "lodash";

interface InputItemProps extends React.DetailedHTMLProps<
  React.InputHTMLAttributes<HTMLInputElement>,
  HTMLInputElement
> {
  label: string;
  className?: string;
  id: string;
  value?: string;
  setValue: (value: string) => void;
  required?: boolean;
  onBlur?: React.FocusEventHandler<HTMLInputElement>;
}
// import { ReactNode } from "react";
export default function InputItem(props: InputItemProps) {
  const {
    label,
    className,
    id,
    placeholder,
    required,
    value,
    setValue,
    onBlur,
    ...rest
  } = props;
  return (
    <>
      <label className="form-label" htmlFor={id}>
        {label}
      </label>
      <input
        autoComplete="off"
        {...rest}
        placeholder={`${placeholder ? `${placeholder}` : "-"}`}
        id={id}
        className={`form-control${className ? ` ${className}` : ""}`}
        value={defaultIfNullish(value)}
        onChange={(e) => setValue(e.target.value)}
        required={required ? required : undefined}
        onBlur={onBlur}
      />
    </>
  );
}
export function TextInputFormik<U>(props: {
  config: ITextEdit<U>;
  formik: FormikProps<any>;
  disabled?: boolean;
  /**
   * If true, the value is not updated until the field is blurred.
   * Useful in large forms to avoid input lag.
   */
  performant?: boolean;
}) {
  const { config, formik, disabled, performant } = props;
  const { id, placeholder, label, isRequired } = config;
  const { values, handleBlur, handleChange } = formik;
  const [innerValue, setInnerValue] = useState<string | undefined>(
    config.initialValue,
  );
  const wasTouched = get(formik.touched, id);
  const errorMessage = get(formik.errors, id) as string | undefined;
  const value = id.split(".").reduce((acc, key) => {
    return acc[key];
  }, values);
  return (
    <>
      <label
        className="form-label"
        style={{ whiteSpace: "nowrap" }}
        htmlFor={id}
      >
        {label ? label : "\u00A0"}
        {isRequired && <IsRequired />}
      </label>
      <input
        autoComplete="off"
        placeholder={`${placeholder ? `${placeholder}` : ""}`}
        type={"text"}
        id={id}
        className={`form-control${
          wasTouched && errorMessage ? " is-invalid" : ""
        }`}
        value={performant ? innerValue : value}
        onChange={(e) => {
          if (performant) {
            setInnerValue(e.target.value);
          } else {
            handleChange(e);
          }
        }}
        onBlur={(e) => {
          if (performant) {
            formik.setFieldTouched(id, true);
            formik.setFieldValue(id, innerValue, true);
          } else {
            handleBlur(e);
          }
        }}
        disabled={disabled}
        onKeyDown={(e) => {
          if (e.key === "Enter") {
            e.preventDefault();
            return false;
          }
        }}
      />
      <ValidationErrorMessage
        touched={wasTouched}
        errorMessage={errorMessage}
      />
    </>
  );
}
